import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const SelectIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
            <g id="Icon / Checkmark">
                <path
                    id="Vector"
                    d="M16.6666 5L7.49992 14.1667L3.33325 10"
                    stroke={props.stroke ?? '#A7A9AC'}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            </g>
        </SvgIcon>
    );
};
